package music.jammers.client.shared.component

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.error_dialog_ok
import limasoul.client.shared.generated.resources.error_dialog_title
import org.jetbrains.compose.resources.stringResource

@Composable
fun ErrorDialog(message: String, onDialogClosed: () -> Unit) {
    AlertDialog(
        title = {
            Text(text = stringResource(Res.string.error_dialog_title))
        },
        text = {
            Text(text = message)
        },
        onDismissRequest = onDialogClosed,
        confirmButton = {
            TextButton(
                onClick = onDialogClosed
            ) {
                Text(stringResource(Res.string.error_dialog_ok))
            }
        },
    )
}